import {
  Box,
  Paper,
  Stack,
  Typography,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";

interface ServiceCardProps {
  name: string;
  price: number;
  items: { name: string; price: number }[];
  total: string;
}

export default function ServiceCard({
  name,
  price,
  items,
  total,
}: ServiceCardProps) {
  return (
    <Paper
      sx={{ flex: 1, borderRadius: "12px", p: 2, boxShadow: 0, height: "100%" }}
    >
      <Stack spacing={2}>
        <Paper
          sx={{
            border: "1.5px solid #f0f4f8",
            borderRadius: "10px",
            p: 2,
          }}
          elevation={0}
        >
          <Stack direction="row" justifyContent="space-between" sx={{ mb: 2 }}>
            <Typography sx={{ fontWeight: 700, fontSize: 15 }}>
              {name}
            </Typography>
            <Typography sx={{ fontWeight: 700, fontSize: 15 }}>
              ${price.toFixed(2)}
            </Typography>
          </Stack>

          {items.length > 0 ? (
            <List disablePadding>
              {items.map((item, idx) => (
                <ListItem key={idx} disableGutters sx={{ py: 0.5 }}>
                  <ListItemText
                    primary={`${item.name}`}
                    primaryTypographyProps={{ fontSize: 12 }}
                  />
                  <Typography sx={{ fontSize: 12 }}>
                    ${item.price.toFixed(2)}
                  </Typography>
                </ListItem>
              ))}
            </List>
          ) : (
            <Box
              sx={{
                bgcolor: "#f0f4f8",
                borderRadius: "8px",
                p: 2,
                textAlign: "center",
                mb: 2,
              }}
            >
              <Typography sx={{ fontSize: 11, color: "#858585" }}>
                No additional services
              </Typography>
            </Box>
          )}

          {/* Total */}
          <Stack direction="row" justifyContent="space-between" sx={{ mt: 2 }}>
            <Typography sx={{ fontWeight: 500, fontSize: 15 }}>
              Total
            </Typography>
            <Typography sx={{ fontWeight: 700, fontSize: 15 }}>
              ${total}
            </Typography>
          </Stack>
        </Paper>
      </Stack>
    </Paper>
  );
}
